import { useState, ReactNode } from "react";
import { Helmet } from "react-helmet-async";

import { cn } from "@reactive-resume/utils";
import { CaretDown } from "@phosphor-icons/react";

interface CollapsibleSectionProps {
  header: ReactNode;
  content: ReactNode;
  defaultOpen?: boolean;
  id?: string;
}

export const CLCollapsibleSection = ({
  header,
  content,
  defaultOpen = false,
  id,
}: CollapsibleSectionProps) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);

  return (
    <section
      id={id || "collapsibleSection"}
      className="grid gap-y-6 px-4 py-3.5 bg-white border-gray-200/80 border-2 rounded-2xl hover:shadow transition-shadow duration-200"
    >
      {id === "css" && (
        <Helmet>
          <link rel="stylesheet" href="/styles/prism-light.css" />
        </Helmet>
      )}
      <header
        className="flex cursor-pointer items-center justify-between"
        onClick={() => setIsOpen((prev) => !prev)}
      >
        {header}

        <button className="text-muted-foreground hover:text-foreground">
          <CaretDown
            size={18}
            className={cn("transition-transform duration-200", isOpen ? "rotate-180" : "rotate-0")}
          />
        </button>
      </header>
      {isOpen && <div>{content}</div>}
    </section>
  );
};
